import { lazy } from 'react';
import { PageRouter } from '@tools/ui/types';
import { UNMATCH_TASKS_MAIN_TABS } from '../pages/unmatch-tasks/i18.unmatch-tasks';

const UnmatchTasksTableDisplay = lazy(
  () =>
    import(
      /* webpackChunkName: "BusyRoutes" */ '../pages/unmatch-tasks/UnmatchTasksTableDisplay'
    )
);

export const unmatchTasksRoutes: PageRouter[] = [
  {
    name: UNMATCH_TASKS_MAIN_TABS.PENDING,
    path: `/${UNMATCH_TASKS_MAIN_TABS.PENDING}`,
    exact: true,
    component: UnmatchTasksTableDisplay,
    tabs: []
  }
];
